import { mockOfficeAgent } from '../agents';
import { mockConversations } from '../conversations';
import { makeStreamStart, makeBlockStart, makeBlockEnd, makeBlockComplete, makeStreamEnd, splitTextIntoDeltas } from '../sseEvents';
const RESPONSE_ID = 'resp-bulk-update';
const CONV_ID = 'conv-6';
const MD_BLOCK_ID = 'blk-bulk-md';
const PROGRESS_BLOCK_ID = 'blk-bulk-progress';
const METRIC_BLOCK_ID = 'blk-bulk-metric';
const PF_BLOCK_ID = 'blk-bulk-pf';
const DEFL_BLOCK_ID = 'blk-bulk-defl';
const markdownText = "I've started updating the status of your selected inspections. " +
    'Here is the progress and a summary of what happened:';
const progressBlock = {
    type: 'progress',
    block_id: PROGRESS_BLOCK_ID,
    block_index: 1,
    agent: mockOfficeAgent,
    message: 'Updating inspection statuses...',
    detail: 'Processing batch 2 of 2',
    percent_complete: 100,
    items_processed: 10,
    items_total: 10,
    show_cancel: false
};
const metricBlock = {
    type: 'metric',
    block_id: METRIC_BLOCK_ID,
    block_index: 2,
    label: 'Successfully Updated',
    value: 8,
    trend: 'up',
    context: '8 of 10 inspections moved to "Completed"'
};
const partialFailureBlock = {
    type: 'partial_failure',
    block_id: PF_BLOCK_ID,
    block_index: 3,
    title: 'Bulk Status Update',
    succeeded_count: 8,
    failed_count: 2,
    total_count: 10,
    failures: [
        {
            resource_type: 'inspection',
            resource_id: 'insp-405',
            label: 'Inspection #405',
            reason: 'Inspection is locked by another user'
        },
        {
            resource_type: 'inspection',
            resource_id: 'insp-612',
            label: 'Inspection #612',
            reason: 'Permission denied — read-only building'
        }
    ],
    actions: []
};
const deflectionBlock = {
    type: 'deflection',
    block_id: DEFL_BLOCK_ID,
    block_index: 4,
    message: 'For the 2 failed updates, you may need to contact your administrator to unlock those inspections.',
    category: 'technical_support',
    support_url: 'https://support.inspectpoint.com',
    support_label: 'Contact Support',
    examples: ['Unlock inspection #405', 'Retry failed updates']
};
const sseSequence = [
    makeStreamStart(RESPONSE_ID, CONV_ID, mockOfficeAgent),
    makeBlockStart(MD_BLOCK_ID, 0, 'markdown'),
    ...splitTextIntoDeltas(MD_BLOCK_ID, markdownText, 16, 50),
    makeBlockEnd(MD_BLOCK_ID),
    makeBlockComplete(progressBlock, 600),
    makeBlockComplete(metricBlock, 300),
    makeBlockComplete(partialFailureBlock, 400),
    makeBlockComplete(deflectionBlock, 300),
    makeStreamEnd(RESPONSE_ID, 5, mockOfficeAgent)
];
export const scenario = {
    name: 'Office Assistant — Bulk Update Results',
    description: 'Bulk update flow with Progress bar, Metric summary, PartialFailure details, and Deflection to support.',
    conversations: mockConversations,
    userMessage: 'Mark all inspections in Building A as completed',
    agentIdentity: mockOfficeAgent,
    sseSequence
};
